import routerOptions0 from "/www/wwwroot/m.ichi-cake.com/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@9.26.0_jiti@2.4_0410b60d2ee78e4fe814aee4b6d70790/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}